import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CruscottoRichiestaService } from '../cruscotto-richiesta.service';
import { Richiesta } from '../../types/Richiesta';
import { UtenteCollegato } from '../../types/UtenteCollegato';

@Component({
  selector: 'app-operatori-coinvolti-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatListModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './operatori-coinvolti-dialog.component.html',
  styleUrl: './operatori-coinvolti-dialog.component.css',
})
export class OperatoriCoinvoltiDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<OperatoriCoinvoltiDialogComponent>);
  readonly data = inject<{ richiesta: Richiesta }>(MAT_DIALOG_DATA);
  private readonly cruscottoRichiestaService = inject(CruscottoRichiestaService);

  utenti: UtenteCollegato[] = [];
  loading = true;
  error: string | null = null;

  ngOnInit(): void {
    const id = this.data?.richiesta?.id;
    if (id == null) {
      this.loading = false;
      this.error = 'Richiesta non valida';
      return;
    }
    this.cruscottoRichiestaService.getUtentiCollegati(id).subscribe({
      next: (list) => {
        this.utenti = list ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = 'Errore nel caricamento degli operatori collegati';
        this.loading = false;
      },
    });
  }
}
